import axios from 'axios';

type GetUnsubscribeIdDTO = {
  unsubscribeId: string;
};

const getUnsubscribeId = async (userId: string) => {
  const { data } = await axios.get<GetUnsubscribeIdDTO>(
    `/user/${userId}/unsubscribe_id`,
  );

  return data?.unsubscribeId;
};

export default getUnsubscribeId;
